import { AvailableLanguagesExtended } from 'franke-trough-dependencies';
import { FSA } from 'flux-standard-action';

export interface SelectLanguagePayload {
  language: AvailableLanguagesExtended;
}

export const CLEAR_LANGUAGE: 'CLEAR_LANGUAGE' = 'CLEAR_LANGUAGE';
export const SELECT_LANGUAGE: 'SELECT_LANGUAGE' = 'SELECT_LANGUAGE';

export const selectLanguage = (language: AvailableLanguagesExtended): FSA<'SELECT_LANGUAGE', SelectLanguagePayload> => ({
  type: SELECT_LANGUAGE,
  payload: {
    language
  },
});

export const clearLanguage = (): FSA<'CLEAR_LANGUAGE', undefined> => ({
  type: CLEAR_LANGUAGE,
});